"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _makeQueryKey = _interopRequireDefault(require("../../utils/make-query-key"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var getGlobalConfigQueryKey = function getGlobalConfigQueryKey() {
  return (0, _makeQueryKey["default"])(['global-config']);
};
var _default = exports["default"] = getGlobalConfigQueryKey;